export const FOLDERS_RESPONSIBLE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FoldersResponsibleUpdated";
export const FOLDER_RESPONSIBLE_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderResponsibleInvalidated";
